import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { corporateSignUpSchema } from '../../schemas/corporateSIgnUpSchema';
import { UserSingUpAPI } from '../../redux/slices/UserSIgnUp';
import { useNavigate } from 'react-router-dom';
import GoogelMapAPI from '../GoogelMapAPI/GoogelMapAPI';

const SignUpForm = () => {

    const [getLocationAttributes, setGetLocationAttributes] = useState({})

    const dispatch = useDispatch();
    const loading = useSelector((state) => state.UserSignUp.loading);
    const navigate = useNavigate()

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    const [addressData, setAddressData] = useState({
        address: getLocationAttributes?.address || '',
        longitude: getLocationAttributes?.longitude || '',
        latitude: getLocationAttributes?.latitude || '',
    });

    // Formik setup
    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            password: '',
            confirm_password: '',
            // address: getLocationAttributes?.address,
            // longitude: getLocationAttributes?.longitude,
            // latitude: getLocationAttributes?.latitude,
            phone_no: '',
            ein_number: '',
            about: '',
            logo: null,
            tax_id_number: '',
            registration_number: '',
            work_permit_id: '',
            other: null,
            role: 'corporate',
        },
        validationSchema: corporateSignUpSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            const payload = { ...values, ...addressData };
            const res = await dispatch(UserSingUpAPI(payload));
            if (res?.payload?.status === 200 || res?.payload?.status === true) {
                navigate("/sign-up/email-varification");
            }
        },
    });

    useEffect(() => {
        if (getLocationAttributes) {
            setAddressData({
                address: getLocationAttributes.address || '',
                longitude: getLocationAttributes.longitude || '',
                latitude: getLocationAttributes.latitude || '',
            });
        }
    }, [getLocationAttributes]);

    return (
        <>
            <div className="signup-form pt-5 pb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 col-lg-5 col-md-12">
                            <h1 className="main-form-heading">Sign Up</h1>
                            <h3 className="second-text-heading">Basic Information:</h3>
                        </div>
                        <div className="col-xl-5 col-lg-5 col-md-12 ps-5" style={{ paddingTop: '32px' }}>
                            <h3 className="second-text-heading">Security Details</h3>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-xl-10 col-lg-10 col-md-12">
                            <form className="container" onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    {/* Left Column */}
                                    <div className="col-md-6 ps-0">
                                        {/* Company Name */}
                                        <div className="mb-3 custom-input-box">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Company Name"
                                                name="name"
                                                value={formik.values.name}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.name && formik.errors.name && (
                                                <div className="error">{formik.errors.name}</div>
                                            )}
                                        </div>

                                        {/* Email Address */}
                                        <div className="mb-3 custom-input-box">
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="Email Address"
                                                name="email"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.email && formik.errors.email && (
                                                <div className="error">{formik.errors.email}</div>
                                            )}
                                        </div>

                                        {/* Password */}
                                        <div className="mb-3 custom-input-box">
                                            <input
                                                type={passwordVisible ? 'text' : 'password'}
                                                className="form-control pass-input"
                                                placeholder="Password"
                                                name="password"
                                                value={formik.values.password}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            <i
                                                className={`fa-solid ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                                                onClick={togglePasswordVisibility}
                                                style={{ cursor: 'pointer' }}
                                            ></i>
                                            {formik.touched.password && formik.errors.password && (
                                                <div className="error">{formik.errors.password}</div>
                                            )}
                                        </div>

                                        {/* Confirm Password */}
                                        <div className="mb-3 custom-input-box">
                                            <input
                                                type={confirmPasswordVisible ? 'text' : 'password'}
                                                className="form-control pass-input"
                                                placeholder="Confirm Password"
                                                name="confirm_password"
                                                value={formik.values.confirm_password}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            <i
                                                className={`fa-solid ${confirmPasswordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                                                onClick={toggleConfirmPasswordVisibility}
                                                style={{ cursor: 'pointer' }}
                                            ></i>
                                            {formik.touched.confirm_password && formik.errors.confirm_password && (
                                                <div className="error">{formik.errors.confirm_password}</div>
                                            )}
                                        </div>

                                        {/* Location */}
                                        <div className="mb-3 custom-input-box">
                                            {/* <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Location"
                                                name="location"
                                                value={formik.values.location}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            /> */}
                                            <GoogelMapAPI setGetLocationAttributes={setGetLocationAttributes} />
                                            {/* {formik.touched.location && formik.errors.location && (
                                                <div className="error">{formik.errors.location}</div>
                                            )} */}
                                        </div>

                                        {/* Phone Number */}
                                        <div className="form-box-inputs flex-column custom-input-box">
                                            <div className='d-flex'>
                                                {/* <input
                                                    type="text"
                                                    className="phone-code"
                                                    name="phoneCode"
                                                    value={formik.values.phoneCode}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                /> */}
                                                <input
                                                    type="number"
                                                    className="phone-number"
                                                    placeholder="Phone Number"
                                                    name="phone_no"
                                                    value={formik.values.phone_no}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                            {formik.touched.phone_no && formik.errors.phone_no && (
                                                <div className="error">{formik.errors.phone_no}</div>
                                            )}
                                        </div>

                                        {/* EIN Number */}
                                        <div className="custom-input-box">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Company EIN Number"
                                                name="ein_number"
                                                value={formik.values.ein_number}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.ein_number && formik.errors.ein_number && (
                                                <div className="error">{formik.errors.ein_number}</div>
                                            )}
                                        </div>

                                        {/* About Company */}
                                        <div className="mb-3 custom-input-box">
                                            <textarea
                                                className="form-control"
                                                placeholder="About Company"
                                                rows="3"
                                                name="about"
                                                value={formik.values.about}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            ></textarea>
                                            {formik.touched.about && formik.errors.about && (
                                                <div className="error">{formik.errors.about}</div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Right Column */}
                                    <div className="col-md-6 ps-5">
                                        {/* Tax ID */}
                                        <div className="mb-3 custom-input-box">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Tax Id Number"
                                                name="tax_id_number"
                                                value={formik.values.tax_id_number}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.tax_id_number && formik.errors.tax_id_number && (
                                                <div className="error">{formik.errors.tax_id_number}</div>
                                            )}
                                        </div>

                                        {/* Registration Number */}
                                        <div className="mb-3 custom-input-box">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Registration Number"
                                                name="registration_number"
                                                value={formik.values.registration_number}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.registration_number && formik.errors.registration_number && (
                                                <div className="error">{formik.errors.registration_number}</div>
                                            )}
                                        </div>

                                        {/* Work Permit ID */}
                                        <div className="mb-3 custom-input-box">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Work Permit Id"
                                                name="work_permit_id"
                                                value={formik.values.work_permit_id}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.work_permit_id && formik.errors.work_permit_id && (
                                                <div className="error">{formik.errors.work_permit_id}</div>
                                            )}
                                        </div>

                                        {/* Logo */}
                                        <div className='d-flex justify-content-between mb-1'>
                                            <div className="logo-box">
                                                <h3 className="second-text-heading">Logo</h3>
                                                <label htmlFor="upload-logo" className="upload-image mb-2">
                                                    <span>Upload Image</span>
                                                </label>
                                                <input
                                                    type="file"
                                                    className="d-none"
                                                    id="upload-logo"
                                                    name="logo"
                                                    accept="image/*" // Restrict file types to images
                                                    onChange={(e) => formik.setFieldValue('logo', e.currentTarget.files[0])}
                                                />
                                                {formik.touched.logo && formik.errors.logo && (
                                                    <div className="error">{formik.errors.logo}</div>
                                                )}
                                            </div>

                                            {formik.values.logo && formik.values.logo.type.startsWith('image/') && (
                                                <img
                                                    src={URL.createObjectURL(formik.values.logo)}
                                                    alt="Uploaded Preview"
                                                    className="uploaded-image-preview"
                                                />
                                            )}
                                        </div>

                                        {/* Supporting Document 1 */}
                                        <div className="logo-box">
                                            <h3 className="second-text-heading">Supporting Document</h3>
                                            <label htmlFor="upload-doc1" className="upload-image mb-2">
                                                <span>Upload Document</span>
                                            </label>
                                            <input
                                                type="file"
                                                className="d-none"
                                                id="upload-doc1"
                                                name="other"
                                                accept=".pdf,.doc,.docx" // Accept PDF and DOC files
                                                onChange={(e) => formik.setFieldValue('other', e.currentTarget.files[0])}
                                            />
                                            {formik.touched.other && formik.errors.other && (
                                                <div className="error">{formik.errors.other}</div>
                                            )}
                                        </div>

                                        {/* Preview or error message */}
                                        {formik.values.other && (
                                            formik.values.other.type === 'application/pdf' ? (
                                                <p className='mt-2'>PDF Document Uploaded</p> // Show message for PDF
                                            ) : formik.values.other.type === 'application/msword' || formik.values.other.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
                                                <p className='mt-2'>Word Document Uploaded</p> // Show message for DOC/DOCX
                                            ) : (
                                                <div className="error mt-2">Invalid file type</div> // Handle invalid file types
                                            )
                                        )}
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="submit-btn-form">
                                    <button
                                        type="submit"
                                        className="btn btn-primary ps-4 pe-4"
                                        disabled={loading}
                                    >
                                        {!loading ? (
                                            "Submit"
                                        ) : (
                                            <i
                                                style={{ fontSize: "22px" }}
                                                className="fa-solid fa-spinner fa-spin"
                                            ></i>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SignUpForm;